import { render } from "./StartAd.vue?vue&type=template&id=5c14ff1c&scoped=true"
import script from "./StartAd.vue?vue&type=script&lang=js"
export * from "./StartAd.vue?vue&type=script&lang=js"

import "./StartAd.vue?vue&type=style&index=0&id=5c14ff1c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c14ff1c"]])

export default __exports__